/**
 * Feature flags — read from window.__ENV__, which is injected at runtime by
 * the Express /config.js endpoint (see server.js). Flags can therefore be
 * toggled via server environment variables without a frontend rebuild.
 *
 * Precedence is resolved server-side and differs per key — see
 * utils/featureFlagResolver.js:
 *   - balance, commissions: an explicitly-set SHOW_* env var wins;
 *     GotaSettings.features (stamped by the business preset) is the default.
 *   - facturacion, esignature: GotaSettings.features wins; the env var is the
 *     fallback for keys the preset does not define.
 *   - warranties, contractTemplates: GotaSettings.features only, no env var.
 *   - termsOfService, privacyPolicy, homePage: env var only, no DB key.
 *
 * Most flags default to false (hidden) when neither source enables them; the
 * two rental-vertical modules below deliberately default to true.
 */
const flags = (typeof window !== 'undefined' && window.__ENV__) || {};

export const isBalanceEnabled = () => flags.SHOW_BALANCE === true;
export const isCommissionsEnabled = () => flags.SHOW_COMMISSIONS === true;
export const isFacturacionEnabled = () => flags.SHOW_FACTURACION === true;
export const isTermsOfServiceEnabled = () => flags.SHOW_TERMS_OF_SERVICE === true;
export const isPrivacyPolicyEnabled = () => flags.SHOW_PRIVACY_POLICY === true;
export const isHomePageEnabled = () => flags.SHOW_HOME_PAGE === true;
// Rental-vertical modules: default ON (undefined = enabled) so existing
// deployments keep them until a business preset explicitly turns them off.
export const isWarrantiesEnabled = () => flags.SHOW_WARRANTIES !== false;
export const isContractTemplatesEnabled = () => flags.SHOW_CONTRACT_TEMPLATES !== false;
export const isEsignatureEnabled = () => flags.SHOW_ESIGNATURE === true;

/**
 * Company logo for on-screen chrome. Both variants ship per client (see
 * frontend/scripts/select-client-assets.js); the light one is the default
 * because it suited the original colored navbar. The topbar is now white
 * (components/Topbar/topbar.css), so clients whose logo is white serve the dark
 * variant instead — decided server-side from CLIENT, see DARK_LOGO_CLIENTS in
 * server.js.
 */
export const getCompanyLogoSrc = () =>
	(flags.USE_DARK_LOGO === true ? '/companyLogoNegro.png' : '/companyLogo.png');
